import { userConstants } from '../_constants';
import { userService } from '../_services';
import { push } from 'connected-react-router';

export const userActions = {
  login,
  logout
};

function login(username, password, previousURL) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
        dispatch(push(previousURL));
      },
      error => {
        dispatch(failure(error));
        dispatch(push('/auth'));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js